import React from "react";
import {Calendar, CardIdentity, ChevronRight, JustifyIcon} from "assets/icons";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";

const DOCUMENT_OPTIONS = [
    {type: "new_permit", Icon: CardIdentity},
    {type: "receipt", Icon: JustifyIcon},
    {type: "anef_extension", Icon: Calendar},
];

const DocumentChoiceStep = ({translate, onClose, onSelect}) => (
    <>
        <Modalheader hide={onClose} hideShow={true}>
            {translate("choice_title")}
        </Modalheader>
        <ModalBody>
            <div className="flex flex-col gap-4">
                <p className="ft-b text-gray-700">{translate("choice_subtitle")}</p>
                <div className="flex flex-col gap-3">
                    {DOCUMENT_OPTIONS.map(({type, Icon}) => (
                        <button
                            key={type}
                            type="button"
                            className="flex items-center gap-3 w-full text-left border border-gray-200 rounded-lg p-4 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            onClick={() => onSelect(type)}
                        >
                            <div className="bg-gray-100 w-[40px] h-[40px] shrink-0 flex justify-center items-center rounded-full">
                                <Icon wh={20} color={"#111827"}/>
                            </div>
                            <div className="flex flex-col flex-1 min-w-0">
                                <span className="ft-b font-medium text-gray-900">{translate(`options.${type}.title`)}</span>
                                <span className="ft-sm text-gray-500">{translate(`options.${type}.subtitle`)}</span>
                            </div>
                            <div className="shrink-0">
                                <ChevronRight wh={20} color={"#6B7280"}/>
                            </div>
                        </button>
                    ))}
                </div>
                <p className="ft-xs text-gray-500">{translate("choice_consent")}</p>
            </div>
        </ModalBody>
    </>
);

export default DocumentChoiceStep;
